export const SET_ANSWER = 'SET_ANSWER'
export const CLEAR_ANSWERS = 'CLEAR_ANSWERS'
export const SET_USER = 'SET_USER'
